import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import accessoriesTotalStyles from './accessoriesTotalStyles';
import Translation from '../../../../../../common/components/translation/Translation';

export interface IAccessoriesTotalProps {
  /**
   * Total number of accessories used to display below the title
   */
  accessoriesTotal: number;
}

const AccessoriesTotal: FunctionComponent<IAccessoriesTotalProps> = ({ accessoriesTotal }) => {
  const styles = accessoriesTotalStyles();

  return (
    <Box display="flex">
      <Typography className={styles.accessoriesTotalValue}>{accessoriesTotal}</Typography>
      <Typography className={styles.accessoriesTotalLabel}>
        <Translation
          id={`spc.customise.accessories.${accessoriesTotal === 1 ? 'item' : 'items'}`}
          values={{ total: accessoriesTotal }}
        />
      </Typography>
    </Box>
  );
};

export default AccessoriesTotal;
